'use client';
import ProposalListItem_V2 from '@/components/Proposal/ProposalListItem_V2';
import { ArrowUpRightIcon } from '@heroicons/react/24/outline';
import ModalForm from '../Modal/Modal';
import { ReactNode, useState } from 'react';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import CustomRichText from '../CustomRichText';

export interface ProposalList_V2Props {
  id?: string;
  title: ReactNode | SerializedEditorState;
  title_2?: ReactNode | SerializedEditorState;
  subtitle: ReactNode | SerializedEditorState;
  list: Array<{
    title: ReactNode | SerializedEditorState;
    subtitle: ReactNode | SerializedEditorState;
  }>;
  color?: 'violet' | 'green' | 'blue';
  showMoreBtn: boolean;
  buttonText?: string;
  btnTag?: string;
}

export default function ProposalList_V2({
  list,
  color = 'green',
  id,
  title,
  title_2,
  subtitle,
  showMoreBtn,
  buttonText,
  btnTag,
}: ProposalList_V2Props) {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);

  const backgroundColorClass =
    {
      green: 'custom-gradient-green-btn',
      blue: 'custom-gradient-blue-btn',
      violet: 'custom-gradient-violet-btn',
    }[color] || 'custom-gradient-green-btn';
  return (
    <>
      <div
        id={id}
        data-meta="ProposalList_V2"
        className="container mx-auto px-4 sm:px-6 lg:px-8 my-14 flex flex-col justify-center rounded-3xl"
      >
        <div className="mt-14">
          <CustomRichText
            data={title}
            tag="h2"
            className="text-3xl font-bold tracking-tight text-center text-white sm:text-6xl mb-4 sm:mb-8"
          />
          {subtitle && (
            <>
              {' '}
              <CustomRichText
                data={subtitle}
                tag="div"
                className="mt-6 text-base text-center lg:text-lg md:leading-6 lg:leading-8 text-white"
              />{' '}
            </>
          )}
          {title_2 && (
            <CustomRichText
              data={title_2}
              tag="div"
              className="mt-4 text-xl font-bold text-center text-white"
            />
          )}
        </div>
        <div className="grid grid-cols-1 gap-2 lg:gap-4 sm:px-6 py-14 lg:px-8">
          {list.map((item, index) => (
            <ProposalListItem_V2 key={index} title={item.title} subtitle={item.subtitle} />
          ))}
        </div>
        {showMoreBtn && (
          <div className="flex justify-center">
            <button
              onClick={openForm}
              className={`pl-8 pr-1 py-1 text-lg font-bold text-white uppercase rounded-full  ring-violet-500 ring-1 flex gap-2 items-center`}
            >
              <span className="max-sm:text-sm">{buttonText}</span>
              <div className={`rounded-full ${backgroundColorClass}`}>
                <ArrowUpRightIcon className="text-white h-4 w-4 m-2" />
              </div>
            </button>
          </div>
        )}
      </div>
      {isFormOpen && (
        <ModalForm closeForm={closeForm} btnMeta={{ tag: btnTag ?? '' }} color={color} />
      )}
    </>
  );
}
